var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.5c0 .25-.125.594-.583 1.018-.459.424-1.177.852-2.15 1.233C17.33 21.509 14.583 22 11.5 22s-5.83-.49-7.767-1.25c-.973-.38-1.691-.808-2.15-1.232C1.125 19.094 1 18.749 1 18.5c0-.25.125-.594.583-1.018.459-.424 1.177-.852 2.15-1.233C5.67 15.491 8.417 15 11.5 15s5.83.49 7.767 1.25c.973.38 1.691.808 2.15 1.232.458.424.583.769.583 1.018z",
    stroke: "#32A3F5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.026 6.585c0 1.557-.78 3.725-2.013 5.933-1.031 1.847-2.315 3.61-3.536 4.913-1.32-1.289-2.6-3.046-3.596-4.899C6.705 10.344 6 8.164 6 6.585 6 3.49 8.479 1 11.513 1s5.513 2.49 5.513 5.585z",
    stroke: "#32A3F5",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.532,
    cy: 6.495,
    r: 2.483,
    fill: "#32A3F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinDrop);
export default __webpack_public_path__ + "static/media/pin-drop.adc2c17c.svg";
export { ForwardRef as ReactComponent };